module.exports = __webpack_public_path__ + "img/cib-logo-only.2cb15139.png";